export const ru = {
    'new-package': 'Новый пакет'
};
